<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ props.titoloMappa }}</p>
                <button class="delete" @click="bSeleziona('chiudi')"></button>
            </header>
            <section class="modal-card-body">
                <div id="map_div" class="contenitore-mappa" v-if="mapLoaded"></div>
                <div v-else class="has-text-centered p-5">Caricamento mappa in corso...</div>
            </section>
            <footer class="modal-card-foot">
            </footer>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, defineProps, defineEmits, nextTick } from "vue";

    const mapLoaded = ref(false);

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        titoloMappa: {
            type: String,
            default: 'Mappa'
        },
        datiMappa: {
            type: Array, 
            default: () => []
            // Formato atteso: { lat: 45.0, lng: 7.0, titolo: '...', colore: 'rosso|giallo|azzurro', payload: { ... } }
        }
    });
    
    const emit = defineEmits(['selezionato', 'elementoSelezionato']);

    // FUNZIONI DEL COMPONENTE
    function bSeleziona(comando) {
        emit('selezionato', comando);
    }

    onMounted(async () => {
        const apiKey = process.env.VUE_APP_MAPS_API_KEY;
        
        try {
            if (!window.google || !window.google.maps) {
                await new Promise((resolve, reject) => {
                    window.initGoogleMapsCallback = () => {
                        resolve();
                        delete window.initGoogleMapsCallback;
                    };
                    const script = document.createElement('script');
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker&loading=async&callback=initGoogleMapsCallback`;
                    script.async = true;
                    script.defer = true;
                    script.onerror = (err) => reject(new Error("Errore nel caricamento script Google Maps: " + err));
                    document.head.appendChild(script);
                });
            }
            
            mapLoaded.value = true;
            await nextTick();
            drawMap();
        } catch (error) {
            console.error("Errore nel caricamento di Google Maps:", error);
        }
    });

    function getIconUrl(colore) {
        // Mappa i colori custom verso i pin standard di Google Maps
        switch(colore) {
            case 'giallo': return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
            case 'azzurro': return "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
            case 'arancione': return "http://maps.google.com/mapfiles/ms/icons/orange-dot.png";
            default: return "http://maps.google.com/mapfiles/ms/icons/red-dot.png"; // default rosso
        }
    }

    function drawMap() {
        if (props.datiMappa.length === 0) return;

        const center = props.datiMappa.length > 0 
            ? { lat: props.datiMappa[0].lat, lng: props.datiMappa[0].lng } 
            : { lat: 45.466797, lng: 7.868775 };

        const mapOptions = {
            center: center,
            zoom: 10,
        };

        const map = new window.google.maps.Map(document.getElementById('map_div'), mapOptions);
        const bounds = new window.google.maps.LatLngBounds();

        props.datiMappa.forEach((punto) => {
            const position = { lat: punto.lat, lng: punto.lng };
            
            // Creo il marker con colore personalizzato
            const marker = new window.google.maps.Marker({
                position: position,
                map: map,
                title: punto.titolo,
                icon: getIconUrl(punto.colore)
            });

            // Aggiungo il Listener del Click sul pin
            marker.addListener('click', () => {
                emit('selezionato', 'chiudi');
                // Passo indietro il payload esatto definito dal genitore
                emit('elementoSelezionato', punto.payload);
            });

            bounds.extend(position);
        });

        if (props.datiMappa.length > 1) {
            map.fitBounds(bounds);
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 80%;
        margin: auto;
    }
    .contenitore-mappa {
        width: 100%;
        height: 500px;
    }
</style>